export const mainGalleryData = [
  {
    id: 12,
    image: '/gallary/10.jpeg',
  },
  {
    id: 12,
    image: '/gallary/35.jpeg',
  },
  {
    id: 12,
    image: '/gallary/36.jpeg',
  },
  {
    id: 12,
    image: '/gallary/37.jpeg',
  },
  {
    id: 12,
    image: '/gallary/38.jpeg',
  },
  {
    id: 12,
    image: '/gallary/39.jpeg',
  },
  {
    id: 12,
    image: '/gallary/40.jpeg',
  },
  {
    id: 12,
    image: '/gallary/41.jpeg',
  },
  {
    id: 12,
    image: '/gallary/42.jpeg',
  },
  {
    id: 12,
    image: '/gallary/43.jpeg',
  },
  {
    id: 12,
    image: '/gallary/44.jpeg',
  },
  {
    id: 12,
    image: '/gallary/45.jpeg',
  },
  {
    id: 12,
    image: '/gallary/46.jpeg',
  },
  {
    id: 12,
    image: '/gallary/47.jpeg',
  },
  {
    id: 12,
    image: '/gallary/48.jpeg',
  },
  {
    id: 12,
    image: '/gallary/49.jpeg',
  },
  {
    id: 12,
    image: '/gallary/50.jpeg',
  },
  {
    id: 12,
    image: '/gallary/51.jpeg',
  },
  
  {
    id: 13,
    image: '/gallary/11.jpeg',
  },
  {
    id: 14,
   image: '/gallary/12.jpeg',
  },
  
  {
    id: 12,
    image: '/gallary/31.jpeg',
  },
  {
    id: 12,
    image: '/gallary/32.jpeg',
  },
  {
    id: 12,
    image: '/gallary/33.jpeg',
  },
  {
    id: 12,
    image: '/gallary/34.jpeg',
  },
  {
    id: 15,
    image: '/gallary/13.jpg',
  },
  {
    id: 16,
    image: '/gallary/14.jpeg',
  },
  {
    id: 17,
   image: '/gallary/16.jpg',
  },
  {
    id: 18,
    image: '/gallary/17.jpg',
  },
  {
    id: 12,
    image: '/gallary/18.jpg',
  },
  {
    id: 12,
    image: '/gallary/19.jpg',
  },
  {
    id: 12,
    image: '/gallary/20.jpg',
  },
  {
    id: 12,
    image: '/gallary/21.jpeg',
  },
  {
    id: 12,
    image: '/gallary/22.jpeg',
  },
  {
    id: 12,
    image: '/gallary/24.jpeg',
  },
  {
    id: 12,
    image: '/gallary/25.jpeg',
  },
  {
    id: 12,
    image: '/gallary/26.jpeg',
  },
  {
    id: 12,
    image: '/gallary/27.jpeg',
  },
  {
    id: 12,
    image: '/gallary/28.jpg',
  },
  {
    id: 12,
    image: '/gallary/29.jpg',
  },
  {
    id: 12,
    image: '/gallary/30.jpeg',
  },
  
 

  {
    id: 8,
    title: 'University Activities',
    category: 'Events',
    image: '/sliderImages/a1.jpeg',
    description: 'Various academic and cultural activities happening across the university campus.'
  },
  {
    id: 7,
    title: 'Government Partnership',
    category: 'Official',
    image: '/sliderImages/apgov.jpeg',
    description: 'Official collaboration and partnership initiatives with the Andhra Pradesh Government.'
  },
  
  {
    id: 9,
    title: 'Campus Life',
    category: 'Campus',
    image: '/sliderImages/a3.jpeg',
    description: 'Vibrant campus life showcasing student activities and university environment.'
  },
  {
    id: 1,
    title: 'University Campus View',
    category: 'Campus',
    image: '/sliderImages/slider_1.jpg',
    description: 'Beautiful panoramic view of Rayalaseema University campus showcasing the architectural excellence.'
  },
  {
    id: 2,
    title: 'Administrative Block',
    category: 'Campus',
    image: '/campuslife/college/ad-building.JPG',
    description: 'The main administrative building where university governance and management operations are conducted.'
  },
   {
    id: 10,
    title: 'Independence Day Celebration',
    category: 'Events',
    image: '/campuslife/college/engineering-building.JPG',
    description: 'Vice Chancellor leading the Independence Day celebrations with great patriotic fervor.'
  },
   {
    id: 11,
    title: 'Independence Day Celebration',
    category: 'Events',
    image: '/campuslife/college/lifesciencebuilding.JPG',
    description: 'Vice Chancellor leading the Independence Day celebrations with great patriotic fervor.'
  },
  {
    id: 3,
    title: 'Academic Complex Block',
    category: 'Campus',
    image: '/gallary/library.jpeg',
    description: 'Modern academic complex housing various departments and state-of-the-art classrooms.'
  },
  {
    id: 4,
    title: 'University Heritage',
    category: 'Campus',
    image: '/gallary/convocation-1.jpeg',
    description: 'Historic view of Rayalaseema University showcasing its legacy and architectural heritage.'
  },
  {
    id: 5,
    title: 'Independence Day Celebration',
    category: 'Events',
    image: '/gallary/studentpledge.jpeg',
    description: 'Vice Chancellor leading the Independence Day celebrations with great patriotic fervor.'
  },
 
  {
    id: 6,
    title: 'Flag Hoisting Ceremony',
    category: 'Events',
    image: '/sliderImages/vcsir-thiranga.jpeg',
    description: 'Ceremonial flag hoisting by the Vice Chancellor during national celebrations.'
  },
  
  
];

// Available categories for filtering
export const galleryCategories = [
  { id: 'All', name: 'All', count: mainGalleryData.length },
  { id: 'Campus', name: 'Campus', count: mainGalleryData.filter(item => item.category === 'Campus').length },
  { id: 'Events', name: 'Events', count: mainGalleryData.filter(item => item.category === 'Events').length },
  { id: 'Official', name: 'Official', count: mainGalleryData.filter(item => item.category === 'Official').length }
];

export default mainGalleryData;